module.exports = __webpack_public_path__ + "assets/webgl/section_2.996a7039.glb";